import React from 'react'

const FooterBlock = ({children}) => {
  return (
    <div className="block25">
        {children}
    </div>
  )
}

export default FooterBlock